import firebase from "../../firebase"
import initializeBMS from "../../mixins/initializeOtherFirebase"

const state = {
    loggedIn: false,
    userProfile: {},
    isAuthenticatedForBMS: false,
}

const getters = {
    userProfile: ({userProfile}) => userProfile,
    loggedIn: ({loggedIn}) => loggedIn,
    isAuthenticatedForBMS: ({isAuthenticatedForBMS}) => isAuthenticatedForBMS
};

const allowedUsers = [
    "berkuralcan@gmail.com",
]

const mutations = {
    USER_DETAILS(state, userProfile) {
        console.log("Running user details")
        
        // Define admin uuids per user

        let admin_uids = [
            "5ssHZrOn0zPZuXgr1wjGRbM7PMp2", // Deniz Dansuk
            "rG7GeyV0pTaMuInmYNwoylisz2l1", // Emine Güven
            
        ]

        let hr_uids = [
            "4emH4idJBTbF1Bh19zlOxr3pjQf2", // İK 
        ]

        let role = "emp"
        let allowsEdit = false

        // state.loggedIn = true
        // Assigning user roles on login

        if(userProfile.uid === '3gxr38Vxqnc4k0hOUxQUKaZSBp22' || userProfile.uid === 'brEtD1CTGNWAyW6EIqFVCUr7Bb43') {
            role = 'superAdmin'
            allowsEdit = true
        } else if (admin_uids.includes(userProfile.uid)){
            role = "admin"
            allowsEdit = true
        } else if (hr_uids.includes(userProfile.uid)){
            role = "hr"
            allowsEdit = true
        }

        if(allowedUsers.includes(userProfile.email) || userProfile.email.toLowerCase().split("@")[1] === "dansuk.com.tr" || userProfile.email.toLowerCase().split("@")[1] === "dgbuildingsolution.de"){
            state.loggedIn = true
        } else {
            state.loggedIn = false
        }

        // Load preferences from localStorage
        let preferences = { crmView: 'list' }; // Default preferences
        try {
            const savedPreferences = localStorage.getItem('userPreferences');
            if (savedPreferences) {
                preferences = { ...preferences, ...JSON.parse(savedPreferences) };
            }
        } catch (error) {
            console.error('Error loading preferences from localStorage:', error);
        }

        state.userProfile = {
            name: userProfile.displayName,
            picture: userProfile.photoURL,
            email: userProfile.email,
            role: role,
            allowsEdit: allowsEdit,
            department: userProfile.department,
            uid: userProfile.uid,
            preferences: preferences
        };


    },

    BMS_LOGGED_IN(state, user){
        if(user){
            state.isAuthenticatedForBMS = true
        }
    },
    BMS_LOG_OUT(state){
        state.isAuthenticatedForBMS = false
    },

    updateUserProfileDepartment(state, department) {
        console.log('Committing department to userProfile:', department);

        state.userProfile.department = department;
    },

    LOGOUT(state){
        state.loggedIn = false;
        state.userProfile = {};
    },

    UPDATE_CRM_PREFERENCE(state, { key, value }) {
        if (!state.userProfile.preferences) {
            state.userProfile.preferences = {};
        }
        state.userProfile.preferences[key] = value;
        
        // Persist to localStorage
        try {
            const preferences = JSON.parse(localStorage.getItem('userPreferences') || '{}');
            preferences[key] = value;
            localStorage.setItem('userPreferences', JSON.stringify(preferences));
        } catch (error) {
            console.error('Error saving preferences to localStorage:', error);
        }
    }

};

const actions = {
    async login(store) {
        if(store.state.loggedIn) return;
        var provider = new firebase.auth.GoogleAuthProvider();
        try {
            console.log("start login");
            await firebase.auth().signInWithRedirect(provider);
            console.log("success login");
        } catch(error) {
            console.log("fail login", error);
        }
    },

    async requestGoogleDriveAccess(){
        if (!firebase.auth().currentUser) {
            throw new Error("User not authenticated");
        }

        const provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope('https://www.googleapis.com/auth/drive.readonly');
        provider.addScope('https://www.googleapis.com/auth/drive.metadata.readonly');
        
        try {
            // Reauthenticate with the new scopes
            // This will only prompt the user for the additional permissions
            const result = await firebase.auth().currentUser.reauthenticateWithPopup(provider);
            
            // Get the access token
            const credential = result.credential;
            const token = credential.accessToken;
            
            console.log("Drive access granted");
            
            // Return the token for making Drive API calls
            return token;
        } catch (error) {
            console.error("Error getting Drive access:", error);
            throw error;
        }
    },
    
    async BMSLogin(store){
        console.log(store.state.isAuthenticatedForBMS)
        if(store.state.isAuthenticatedForBMS) {
            return
        }
        const provider = new firebase.auth.GoogleAuthProvider()

        try{
            await initializeBMS.methods.initializeBMS().auth().signInWithRedirect(provider)
        } catch(error) {
            console.log(error)
        }
    },

    async updateTeamMemberDetails (context, userData){
        // TODO - Remove this function.
        console.log("TEMPORARY FUNCTION: Updating team member details:", userData);
        try {
            const userRef = firebase.firestore().collection("team").doc(userData.id);
            const userDoc = await userRef.get();
            
            if(!userDoc.exists){
                // Create new profile if doesn't exist
                await userRef.set({
                    id: userData.id,
                    name: {
                        first: userData.name.first,
                        last: userData.name.last,
                    },
                    emailAddress: userData.emailAddress,
                    profileImage: userData.profileImage,
                    birthday: "",
                    department: "engineering",
                });
                console.log("Created new user profile for:", userData.id);
            } else {
                // Update only missing fields (emailAddress and profileImage)
                const updateData = {};
                const existingData = userDoc.data();
                
                if (!existingData.emailAddress && userData.emailAddress) {
                    updateData.emailAddress = userData.emailAddress;
                }
                if (!existingData.profileImage && userData.profileImage) {
                    updateData.profileImage = userData.profileImage;
                }
                
                // Only update if there are missing fields to update
                if (Object.keys(updateData).length > 0) {
                    await userRef.update(updateData);
                    console.log("Updated missing fields for user:", userData.id, updateData);
                } else {
                    console.log("No missing fields to update for user:", userData.id);
                }
            }
        } catch (error) {
            console.error("Error updating team member details:", error);
            throw error;
        }
    },

    async teamMemberDetails({ commit }, userId){
        console.log("Running team member details with userID:", userId);
        const userRef = firebase.firestore().collection("team").doc(userId);
        const userDoc = await userRef.get();
        if(userDoc.exists){
            commit('updateUserProfileDepartment', userDoc.data().department);
        } else {
            console.log("User does not exist.");
        }
    },


    async logout(){
        try {
            await firebase.auth().signOut();
        } catch(error) {
            console.log(error)
        }
    },

    changeCrmPreference({ commit }, { key, value }) {
        commit('UPDATE_CRM_PREFERENCE', { key, value });
    }
}

export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}